import * as ModalDialogs from 'vue-modal-dialogs'
import './vue-modal-dialogs.css'

const plugin = {
  install (Vue) {
    Vue.use(ModalDialogs)
  }
}

export default plugin



// WEBPACK FOOTER //
// ./~/vue-components/plugins/vue-modal-dialogs/vue-modal-dialogs.js